import { render, staticRenderFns } from "./index_duty_manager.vue?vue&type=template&id=87c0e2d6&"
import script from "./index_duty_manager.vue?vue&type=script&lang=js&"
export * from "./index_duty_manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports